<template>
    <div>
        <!-- banner -->
        <Banner></Banner>
        <!-- 招聘企业 -->
        <Enterprise></Enterprise>
        <!-- 热门职位 -->
        <Position></Position>
        <!--<img src="@/pages/frontend/assets/images/content.png" alt="" style="width:100%">-->
        <img src="/files?imagePath=/banner/banner-middle.png" alt="" style="width:100%">
        <!-- 推荐人才 -->
        <Personnel></Personnel>
    </div>
</template>
<script>
    // new Tab('#gzsjs .hds li','#gzsjs .bds > div',1,"click",1000);
    import {Banner, Enterprise, Position, Personnel} from './components';

    export default {
        components: {
            Banner,
            Enterprise,
            Position,
            Personnel
        }
    };
</script>